<template>
  <div>
    <h3 class="page__title">网点资料信息发布</h3>
    <div class="form_container">
      <form class="form">
        <!--        //@submit.prevent="publishMessage"-->
        <div class="form_row">
          <div class="label"><label for="openid">OpenID：</label></div>
          <input id="openid" v-model="openid" class="input" readonly type="text">
        </div>
        <div class="form_row">
          <div class="label"><label for="id">上传信息ID：</label></div>
          <input id="id" v-model="id" class="input" readonly type="text">
        </div>
        <!--                <div class="form_row">
                          <div class="label"><label for="message">消息内容：</label></div>
                          <input id="message" v-model="message" class="input">
                        </div>
                <div class="form_row">
                            //class="button_container"

                            <button class="weui-btn weui-btn_primary" type="submit">发布</button>
                </div>-->
        <div id="session_container" class="form_column">
          <div class="label_row_message">当前回话消息：</div>
          <div class="element-select">
            <div class="element-select1">
              <el-select v-model="selectedCuePhrasesValue" class="my-select" placeholder="请选择要发送的提示语">
                <el-option
                  v-for="item in sessionSelect"
                  :key="item.id"
                  :label="item.text"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="element-select1">
              <el-input v-model="inputCuePhrases" class="input_row" placeholder="请输入要发送的提示语"></el-input>
            </div>
            <div class="element-select1">
              <el-button class="input_row" type="primary" @click="publishMessage(selectedCuePhrasesText)">发送消息
              </el-button>
            </div>
          </div>
        </div>
      </form>
    </div>

  </div>
</template>

<script>

import mqtt from "mqtt";

var mqttClient = null
const mqttUrl = "wss://mqtt.nationaiot.com/mqtt"
const mqttOptions = {
  connectTimeout: 3000,
  clientId: 'omc-material-sendMsg',
  username: 'ccnet',
  password: 'ccnet0901',
  clean: false,
}


// const topic = `ccnet/down/man/${openid}`
export default {
  data() {
    return {
      id: '', //传过来采集员申报信息的id，唯一值
      openid: '',  //传过来采集员的openid
      //message: '',
      selectedCuePhrasesValue: '1',//select选中的提示语信息的id
      inputCuePhrases: '',//输入框输入的提示语
      selectedCuePhrasesText: '请上传清晰的网点地理位置图片和位置信息',
      sessionSelect: [
        {
          id: '1',
          text: '请上传清晰的网点地理位置图片和位置信息',
        }, {
          id: '2',
          text: '请上传清晰的正视图并尽量补充完整描述信息',
        }, {
          id: '3',
          text: '请上传清晰的左视图并尽量补充完整描述信息',
        }, {
          id: '4',
          text: '请上传清晰的右视图并尽量补充完整描述信息',
        }, {
          id: '5',
          text: '请上传清晰的后视图并尽量补充完整描述信息',
        }, {
          id: '6',
          text: '请上传清晰的俯视图并尽量补充完整描述信息',
        }, {
          id: '7',
          text: '请上传清晰的周边环境图片并尽量补充完整描述信息',
        }, {
          id: '8',
          text: '请上传清晰的网点营业时间图片并尽量补充完整描述信息',
        }, {
          id: '9',
          text: '请上传清晰的联系方式图并尽量补充完整描述信息',
        }, {
          id: '10',
          text: '请上传清晰的价目表图并尽量补充完整价目表信息',
        }, {
          id: '11',
          text: '请上传清晰的网点免责条款图并补充完整的条款信息',
        }, {
          id: '12',
          text: '请上传清晰的服务向导图并尽量补充完整的服务信息',
        }, {
          id: '13',
          text: '请上传清晰的服务介绍视频并尽量补充完整描述信息',
        }, {
          id: '14',
          text: '请上传清晰的网点注册二维码图并尽量补充完整描述信息',
        }, {
          id: '15',
          text: '请上传清晰的网点启动二维码图并尽量补充完整描述信息',
        },
      ],
    }
  },
  created() {
    if (this.$route.params.openid) {
      this.openid = this.$route.params.openid;
      this.id = this.$route.params.id
    }
    this.mqttClient()
  },
  destroyed() {
    this.stopWork()
  },
  watch: {
    selectedCuePhrasesValue: function () {
      for (const item of this.sessionSelect) {
        if (this.selectedCuePhrasesValue === item.id) {
          this.selectedCuePhrasesText = item.text;
        }
      }
    },
    inputCuePhrases: function () {
      this.selectedCuePhrasesText = this.inputCuePhrases;
      console.log('当前发送的提示语是', this.selectedCuePhrasesText);
    }
  },
  methods: {
    stopWork() {
      if (mqttClient) {
        mqttClient.end();
        mqttClient = null;
      }
    },
    publishMessage(message) {
      // let that = this;
      const topic = `ccnet/down/man/${this.openid}`
      const payload = {
        messageData: message,
        messageId: this.id,
      }
      let element = document.getElementById('session_container');
      element.scrollTop = element.scrollHeight + element.clientHeight;
      mqttClient.publish(topic, JSON.stringify(payload), {qos: 2, retain: false}, function (error) {
        if (!error) {
          console.log('MQTT message published', payload.messageData)
        } else {
          console.log('MQTT publish error:', error, '消息发送失败')
        }
      })
      mqttClient.on('message', (topic, payload) => {
        console.log("收到来自", topic, "的消息:", payload.toString())
      })
      alert("发送成功");
      this.$router.push('/material_query')
    },
    mqttClient() {
      this.stopWork();
      if (!mqttClient) {
        mqttClient = mqtt.connect(mqttUrl, mqttOptions)
      }
      mqttClient.on('connect', (e) => {
        console.log("连接成功")
      })
    },
  }
}


</script>

<!--<style scoped src="../css/pos_detail.css">-->
<style scoped src="../css/material_sendMsg.css">
</style>



// WEBPACK FOOTER //
// src/views/material_sendMsg.vue